export default {
      id: "Icon--checklist-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--checklist",
      toString: function () {
        return this.url;
      }
    }